module.exports = __webpack_public_path__ + "img/6.1bf4df93.png";